import shoutbaseIconPlay from "../images/electron/shoutbase_icon_play.png"

let ipc
if (window.require) {
    const { ipcRenderer, shell } = window.require("electron")
    ipc = ipcRenderer

    window.onclick = function(event) {
        const isAnchorTag = event.target.nodeName.toString() === "A"
        const isOpenedExternally =
            event.target.getAttribute("target") === "_blank"

        if (isAnchorTag && isOpenedExternally) {
            const href = event.target.getAttribute("href")

            event.preventDefault()
            shell.openExternal(href)
        }
    }
} else {
    ipc = {
        on: () => {},
        send: () => {},
    }
}
export default ipc

let isDarkMode = false

ipc.on("setDarkMode", (event, mode) => {
    isDarkMode = mode
})

export const updateElectronDuration = (duration, running) => {
    ipc.send("fetchDarkModeSetting")

    if (duration > 99.99) {
        duration = ">100"
    }

    const stopImage = document.createElement("img")
    stopImage.setAttribute("src", shoutbaseIconPlay)

    const canvas = document.createElement("canvas")

    const baseWidth = 47
    const durationStr = `${duration}`
    const widthOffset = (durationStr.length - 3) * 6

    if (running) {
        canvas.width = baseWidth + widthOffset
        canvas.height = 40
        const context = canvas.getContext("2d")

        context.fillStyle = isDarkMode ? "white" : "black"
        context.font = "13px Rubik,Helvetica,Sans-serif"
        context.fillText(running ? duration + "h" : "stopped", 2, 25)

        context.drawImage(stopImage, canvas.width - 12, 12)
        const data = canvas.toDataURL("image/png")

        ipc.send("changeIcon", data)
    } else {
        ipc.send("resetIcon")
    }
}

//This was found at https://ourcodeworld.com/articles/read/525/how-to-check-if-your-code-is-being-executed-in-electron-or-in-the-browser
export const isElectron = () => {
    return (
        (typeof window !== "undefined" &&
            typeof window.process === "object" &&
            window.process.type === "renderer") ||
        (typeof navigator === "object" &&
            typeof navigator.userAgent === "string" &&
            navigator.userAgent.indexOf("Electron") >= 0)
    )
}



// WEBPACK FOOTER //
// ./src/util/electron_ipc.js